export default function Transportation() {
  return (
    <section style={{ textAlign: "center", padding: "60px 20px" }}>
      <div style={{ fontSize: "80px", marginBottom: "20px" }}>🚧</div>

      <h1 style={{ fontSize: "2.2rem", color: "#2f6f89" }}>
        Page Under Construction
      </h1>

      <p style={{ fontSize: "1.2rem", maxWidth: "600px", margin: "20px auto" }}>
        We're still building this page at <strong>Hopeful Horizons NY</strong>.
        Please check back soon!
      </p>

      <div style={{ fontSize: "40px", marginTop: "20px" }}>
        🚗 🛠️ ✨
      </div>
    </section>
  );
}